import { render } from "./ItemPicker.vue?vue&type=template&id=1aa8bb07"
import script from "./ItemPicker.vue?vue&type=script&lang=js"
export * from "./ItemPicker.vue?vue&type=script&lang=js"

import "./ItemPicker.vue?vue&type=style&index=0&id=1aa8bb07&lang=scss"
script.render = render

export default script